import {useQuery} from "@tanstack/react-query"
import {useMemo} from "react"
import {useModel} from "hooks/useModel"
import {eventTypeService} from "services"
import {getStudentDataTemplateFields, TemplateFieldGroup} from "types/templates"

const useTemplateFieldsSettings = () => {
    const model = useModel()
    const studentFields = useMemo(() => getStudentDataTemplateFields(model), [model])

    const {data: eventTypes, isSuccess} = useQuery(["calendar-event-types"], async () => {
        const {data} = await eventTypeService.getAll({range: {limit: 100, offset: 0}})
        return data
    })

    const templateFields = useMemo<TemplateFieldGroup[]>(() => {
        if (!isSuccess || !eventTypes) {
            return studentFields
        }

        return [
            ...studentFields,
            {
                label: "Event Types",
                options: eventTypes.map((option) => ({
                    id: `eventType:${option.eventTypeId}`,
                    name: `${option.name} (${option.code})`
                }))
            }
        ]
    }, [studentFields, eventTypes, isSuccess])

    return {templateFields}
}

export {useTemplateFieldsSettings}
